import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { axiosRequest } from "../helpers/axios";
import { isPublicAuthFlowPath } from "../helpers/constants";

export const useUserInfo = (url: string): [boolean,boolean,(value: React.SetStateAction<boolean>) => void] => {
    const { pathname } = useLocation();
    const [isUserSawBanner, setIsUserSawBanner] = useState(false)
    const [loadedUserInfo, setLoadedUserInfo] = useState<boolean>(false);
    useEffect(() => {
        if (isPublicAuthFlowPath(pathname)) {
            setLoadedUserInfo(true);
            return;
        }

        const getIsUserSawBanner = async () => {
            await axiosRequest("GET", "/wp-json/pg/v1/user/sawbanner").then((response) => {
                if(response.data.has_seen_banner){
                    setIsUserSawBanner(true)
                }
                setLoadedUserInfo(true)
            }).catch(error => console.error(`Error: ${error}`));
        }
        getIsUserSawBanner();
    }, [url, pathname]);

    return [isUserSawBanner,loadedUserInfo,setIsUserSawBanner];
}